// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppInternalStatus_wrapper"};